import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

// material-ui components
import withStyles from '@material-ui/core/styles/withStyles';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

// core components
import SweetAlert from 'components/SweetModal/SweetAlert';
import GridContainer from 'components/Grid/GridContainer';
import ItemGrid from 'components/Grid/ItemGrid';
import ProfileCard from 'components/Cards/ProfileCard';
import Button from 'components/CustomButtons/Button';
import CustomInput from 'components/CustomInput/CustomInput';
import ErrorBoundaries from 'components/Wrapper/ErrorBoundaries';
// @material-ui/icons
import Email from '@material-ui/icons/Email';

// config / helper / style
import config from 'config';
import { verifyEmail } from 'helpers/helpers';
import ForgotPasswordPageStyle from 'views/Auth/style/forgotPasswordPageStyle';

class ForgotPasswordPage extends React.Component {
  // cardAnimaton: to make the card to appear after the page has been rendered
  state = {
    successAlert: null,
    successAlertMessage: '',
    warningAlert: null,
    email: '',
    emailState: '',
    sms: false,
  };

  change(value, type) {
    switch (type) {
      default:
      case 'email':
        this.setState({
          email: value.toLowerCase(),
          emailState: verifyEmail(value) ? 'success' : 'error',
        });
        break;
      case 'sms':
        this.setState({ sms: !this.state.sms });
        break;
    }
  }

  registerClick = (e) => {
    e.preventDefault();

    if (this.state.emailState === '') {
      this.setState({ emailState: 'error' });
    }

    if (this.state.emailState === 'success') {
      axios
        .post(`${config.API_URL}/public/auth/forgot_password`, {
          email: this.state.email,
          sms: this.state.sms.toString(),
        })
        .then((res) => {
          this.successAlert(res.data.message);
        })
        .catch(() => {
          this.warningAlert();
        });
    }
  };

  warningAlert() {
    this.setState({ warningAlert: true });
    setTimeout(this.hideWarningAlert, 4000);
  }

  successAlert = (message) => {
    this.setState({
      email: '',
      sms: false,
      successAlert: true,
      successAlertMessage: message,
    });
    setTimeout(this.hideSuccessAlert, 4000);
  };

  hideWarningAlert = () => {
    this.setState({ warningAlert: null });
  };
  hideSuccessAlert = () => {
    this.props.history.push('/auth/connexion');
  };

  render() {
    const { classes } = this.props;
    const { warningAlert, successAlert, successAlertMessage } = this.state;
    return (
      <ErrorBoundaries>
        <Fragment>
          {warningAlert && (
            <SweetAlert
              warning
              title='Huston, on a eu un problème !'
              onConfirm={this.hideWarningAlert}
              confirmBtnText='Ok'
              text="Nous n'avons pas pu trouver votre compte. Vérifier votre adresse
          email."
            />
          )}
          {successAlert && (
            <SweetAlert
              success
              title={'Le message vient de vous être envoyé !'}
              onConfirm={this.hideSuccessAlert}
              onCancel={this.hideSuccessAlert}
              confirmBtnText='Ok'
              text={successAlertMessage}
            />
          )}
          <div className={classes.content}>
            <GridContainer justifyContent='center'>
              <ItemGrid xs={12} sm={6} md={4} lg={3}>
                <form onSubmit={(e) => this.registerClick(e)}>
                  <ProfileCard
                    customCardClass={`${classes.customCardClass} ${classes.card}`}
                    customCardAvatarClass={classes.customCardAvatarClass}
                    customCardFooterClass={classes.customCardFooterClass}
                    customCardTitleClass={classes.customCardTitleClass}
                    title='Réinitialiser mot de passe'
                    avatar={null}
                    content={
                      <Fragment>
                        <CustomInput
                          success={this.state.emailState === 'success'}
                          error={this.state.emailState === 'error'}
                          labelText='Email *'
                          id='email'
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            placeholder: 'prenom.nom@mail.com',
                            type: 'email',
                            startAdornment: (
                              <InputAdornment position='start'>
                                <Email className={classes.inputAdornmentIcon} />
                              </InputAdornment>
                            ),
                            onChange: (event) => this.change(event.target.value, 'email'),
                            value: this.state.email,
                          }}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={this.state.sms}
                              onChange={({ target: { value } }) => this.change(value, 'sms')}
                              value='sms'
                              color='primary'
                            />
                          }
                          label='Envoyer le lien par sms'
                        />
                      </Fragment>
                    }
                    footer={
                      <Button color='primary' type='submit'>
                        Valider
                      </Button>
                    }
                  />
                </form>
              </ItemGrid>
            </GridContainer>
          </div>
        </Fragment>
      </ErrorBoundaries>
    );
  }
}

ForgotPasswordPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(ForgotPasswordPageStyle)(ForgotPasswordPage);
